if (!customElements.get('abc-mobile-card-gallery')) {
  customElements.define('abc-mobile-card-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.media) return;
      this.media = window.matchMedia('(max-width: 749px)');
      this.onMedia = () => this.media.matches ? this.mount() : this.unmount();
      this.media.addEventListener('change', this.onMedia);
      this.onMedia();
    }

    disconnectedCallback() {
      this.unmount();
      this.media?.removeEventListener('change', this.onMedia);
      this.media = null;
    }

    mount() {
      if (this.dataset.ready) return;
      const template = this.querySelector('template');
      if (!template) return;
      this.append(template.content.cloneNode(true));
      this.track = this.querySelector('.abc-mobile-card-gallery__track');
      this.slides = [...this.track.children];
      this.previous = this.querySelector('[data-gallery-step="-1"]');
      this.next = this.querySelector('[data-gallery-step="1"]');
      this.counter = this.querySelector('[data-gallery-current]');
      this.currentIndex = 0;
      this.dataset.ready = 'true';
      this.closest('.abc-store-card').dataset.mobileGalleryReady = 'true';
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.tapGesture = null;
      this.blockOpenUntil = 0;
      this.track.addEventListener('dragstart', (event) => event.preventDefault(), options);
      this.track.addEventListener('pointerdown', (event) => {
        if (event.isPrimary === false) {
          if (this.tapGesture) this.tapGesture.moved = true;
          return;
        }
        if (event.button !== 0) return;
        this.blockOpenUntil = 0;
        this.tapGesture = { id: event.pointerId, x: event.clientX, y: event.clientY, moved: false };
      }, options);
      this.track.addEventListener('pointermove', (event) => {
        const gesture = this.tapGesture;
        if (!gesture || gesture.id !== event.pointerId) return;
        if (Math.hypot(event.clientX - gesture.x, event.clientY - gesture.y) > 10) gesture.moved = true;
      }, { ...options, passive: true });
      this.track.addEventListener('pointerup', (event) => {
        const gesture = this.tapGesture;
        if (!gesture || gesture.id !== event.pointerId) return;
        if (gesture.moved || Math.hypot(event.clientX - gesture.x, event.clientY - gesture.y) > 10) this.blockOpenUntil = performance.now() + 650;
        this.tapGesture = null;
      }, options);
      this.track.addEventListener('pointercancel', () => {
        this.tapGesture = null;
        this.blockOpenUntil = performance.now() + 650;
      }, options);
      this.track.addEventListener('click', (event) => {
        if (!event.target.closest('a.abc-mobile-card-gallery__slide')) return;
        if (event.detail !== 0 && (this.tapGesture?.moved || performance.now() < this.blockOpenUntil)) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, { ...options, capture: true });
      this.track.addEventListener('scroll', () => {
        if (this.tapGesture) this.tapGesture.moved = true;
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.update();
        });
      }, { ...options, passive: true });
      this.track.addEventListener('keydown', (event) => {
        const actions = { ArrowLeft: this.currentIndex - 1, ArrowRight: this.currentIndex + 1, Home: 0, End: this.slides.length - 1 };
        if (!(event.key in actions)) return;
        event.preventDefault();
        this.goTo(actions[event.key]);
      }, options);
      this.querySelectorAll('[data-gallery-step]').forEach((button) => {
        button.addEventListener('click', () => this.goTo(this.currentIndex + Number(button.dataset.galleryStep)), options);
      });
      this.lastWidth = this.track.clientWidth;
      this.resizeObserver = new ResizeObserver(() => {
        const width = this.track?.clientWidth;
        if (!width || width === this.lastWidth) return;
        this.lastWidth = width;
        this.track.scrollTo({ left: width * this.currentIndex, behavior: 'instant' });
        this.update();
      });
      this.resizeObserver.observe(this.track);
      this.update();
    }

    goTo(index) {
      const target = Math.max(0, Math.min(index, this.slides.length - 1));
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: target * this.track.clientWidth, behavior: reducedMotion ? 'instant' : 'smooth' });
    }

    update() {
      const width = this.track.clientWidth;
      if (!width) return;
      this.currentIndex = Math.max(0, Math.min(Math.round(this.track.scrollLeft / width), this.slides.length - 1));
      if (this.counter) this.counter.textContent = String(this.currentIndex + 1);
      if (this.previous) this.previous.disabled = this.currentIndex === 0;
      if (this.next) this.next.disabled = this.currentIndex === this.slides.length - 1;
    }

    unmount() {
      this.events?.abort();
      this.resizeObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.tapGesture = null;
      this.blockOpenUntil = 0;
      this.querySelector('.abc-mobile-card-gallery__body')?.remove();
      delete this.dataset.ready;
      const card = this.closest('.abc-store-card');
      if (card) delete card.dataset.mobileGalleryReady;
      this.track = null;
    }
  });
}
